/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'order',
    quality: 0.1,
    learning: 1,
    perception: -1,
	strength: 1,
}